/**
 * Placeholder / fallback copy for Royalties ANZ empty state and table errors
 * (APP-2082).
 *
 * The historical cut-off banner is shared across regions and lives in
 * `constant/royaltiesHistoricalBanner` — each region owns its own Parameter
 * Store keys there, so ANZ wording never leaks onto World.
 */
import {
  ROYALTIES_ANZ_HISTORICAL_BANNER_KEYS,
  ROYALTIES_HISTORICAL_BANNER_FALLBACK,
} from './royaltiesHistoricalBanner';

export const royaltiesAnzCopy = {
  /**
   * Shown when there are no finalised ANZ royalty rows (page 1, no search).
   * Must not imply an error or that money is owed.
   * TODO: Confirm copy with Member Services
   */
  emptyState: {
    description:
      'When ANZ royalty statements are available for this workspace, they will appear here.',
    title: 'No Royalties ANZ statements yet',
  },
  /**
   * Fallback for the persistent, non-dismissible banner above Royalties ANZ
   * content. Shared with every other region — prefer the ANZ config keys in
   * {@link ROYALTIES_ANZ_HISTORICAL_BANNER_KEYS}.
   */
  historicalBanner: ROYALTIES_HISTORICAL_BANNER_FALLBACK,
  /**
   * Compact in-card error when the list fetch fails with no prior page to keep.
   */
  loadError: {
    bodyAfterRetry: ' the page.',
    bodyBeforeRetry:
      "We couldn't load these statements. Try adjusting your search or ",
    title: 'Something went wrong.',
  },
  /**
   * Compact in-card error when a refresh fails but keepPreviousData still has rows.
   */
  refreshError: {
    bodyAfterRetry: ' the page.',
    bodyBeforeRetry:
      "We couldn't refresh these statements. Showing the last loaded results — try adjusting your search or ",
    title: 'Something went wrong.',
  },
  /**
   * In-table empty copy when a search returns zero matches (keeps the search
   * field). Shared by Title and Earnings tables.
   */
  searchNoResultsEmpty: {
    description: "We couldn't find what you are looking for.",
    icon: 'search' as const,
    title: 'No results found',
  },
} as const;
